<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="合作建造" @back="goBack" /></span>
          <el-card style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel
                  ref="CommonExcelRef"
                  :import-p="'config:rewardBuildPartnersEdit:import'"
                  :export-p="'config:rewardBuildPartnersEdit:export'"
                  :import-method="importBaseCfg"
                  :export-method="exportBaseCfg"
                />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template slot-scope="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="120">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="120">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" width="200" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="基础倍数" width="110">
                <template slot-scope="{row, $index}">
                  <el-input v-model.number="row.baseBet" placeholder="基础倍数" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="初始化道具数量" width="120">
                <template slot-scope="{row, $index}">
                  <el-input v-model.number="row.initRewards" placeholder="初始化道具数量" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="收集物数量" width="120">
                <template slot-scope="{row, $index}">
                  <el-input v-model.number="row.itemNum" placeholder="收集物数量" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="兑换比例" width="120">
                <template slot-scope="{row, $index}">
                  <el-input v-model.trim="row.exchangeRate" placeholder="兑换比例" />
                </template>
              </el-table-column>
              <el-table-column label="建造配置" align="center" width="125">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.buildStageConfig">
                    <el-option v-for="item in list[1]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="转盘配置" align="center" width="125">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.wheelConfig">
                    <el-option v-for="item in list[2]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="礼包配置" align="center" width="125">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.giftConfig">
                    <el-option v-for="item in list[3]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="Bet" width="250">
                <template slot-scope="{row, $index}">
                  <el-select v-model="row.bets" style="width: 100%;" multiple placeholder="请选择">
                    <el-option v-for="item in betOptions" :key="item.value" :label="item.label" :value="item.value"/>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="完成奖励" width="125">
                <template slot-scope="{row, $index}">
                  <Reward :value="row.lastRewards" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <el-button v-permisaction="['config:rewardBuildPartnersEdit:del']" size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button v-permisaction="['config:rewardBuildPartnersEdit:add']" type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button v-permisaction="['config:rewardBuildPartnersEdit:add']" type="primary" :disabled="isOnline === 1" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { getActivtyList, updateActivtyRewardConfData } from '@/api/config/activity-cfg'
import CommonExcel from '@/components/CommonExcel/index.vue'
import { downloadExcelMultiSheet } from '@/utils/excel'
import Reward from '@/components/Reward/index.vue'
export default {
  name: 'RewardBuildPartnersEdit',
  components: { Reward, CommonExcel },
  data() {
    return {
      list: [],
      baseList: [],
      groupsList: [{ name: '默认分组', id: 0 }],
      curClass: 'build_partners',
      rewardConf: [],
      shopSku: [],
      isOnline: 0,
      betOptions: [
        { label: '倍数1', value: 1 },
        { label: '倍数2', value: 2 },
        { label: '倍数3', value: 3 },
        { label: '倍数5', value: 5 },
        { label: '倍数10', value: 10 },
        { label: '倍数20', value: 20 },
        { label: '倍数30', value: 30 }
      ]
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.curClass = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.init()
  },
  methods: {
    init() {
      this.getActivity()
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
      })
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, maxNum: 1, groupIds: [], baseBet: 0, initRewards: 0, itemNum: 0, exchangeRate: 0, buildStageConfig: 0, wheelConfig: 0, goodsConfig: 0, giftConfig: 0, lastRewards: [], bets: [] })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    handleSaveBase() {
      for (const i in this.baseList) {
        const val = this.baseList[i]
        if (!val.groupIds) {
          this.msgError('请选择分组')
          return
        }
      }
      const data = JSON.stringify(this.baseList)
      updateActivtyRewardConfData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getActivity() {
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          let baseList = res.data.list[0].reward_conf
          if (typeof baseList === 'object' && !Array.isArray(baseList)) {
            baseList = []
          }
          this.baseList = baseList
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, buildStageConfig: this.list[1], wheelConfig: this.list[2], giftConfig: this.list[2] }, true, 'name', 'id')
        break
      }
    },
    exportBaseCfg() {
      const fileName = '合作建造'
      const hearer = []
      const excelData = []
      const name = ['合作建造']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, buildStageConfig: this.list[1], wheelConfig: this.list[2], giftConfig: this.list[3] }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, baseBet: '基础倍数', initRewards: '初始化给的活动道具数据', itemNum: '收集物数量', exchangeRate: '兑换比例', buildStageConfig: '建造配置', wheelConfig: '转盘配置', giftConfig: '礼包配置', lastRewards: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}})
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    }
  }
}
</script>

<style scoped>
</style>
